import React from "react";
import { Link } from "react-router-dom";
import { SOLUTIONS } from "../constants";

export const Footer: React.FC = () => (
  <footer className="py-10 px-6 border-t border-white/5 bg-[#050505]">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-16 md:gap-12 text-center md:text-left items-center md:items-start">
      <div className="max-w-xs flex flex-col items-center md:items-start">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center font-bold text-black italic">S</div>
          <div>
            <span className="text-xl font-bold tracking-tighter">SetupOnline</span>
            <p className="text-[10px] uppercase tracking-[0.4em] font-bold text-orange-500 block -mt-1">Digital Solutions</p>
          </div>
        </div>
        <p className="text-white/50 text-sm font-light leading-relaxed">
          The global standard for custom enterprise software. Empowering D2C brands and organizations to operate with high-end digital infrastructure.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-12 text-sm w-full md:w-auto">
        <div className="space-y-4">
          <h5 className="font-bold text-white/40 uppercase tracking-widest text-[10px]">Product</h5>
          <ul className="space-y-3 text-white/60">
            {SOLUTIONS.map(sol => (
              <li key={sol.id}>
                <Link to={`/solutions/${sol.id}`} className="hover:text-orange-500 transition-colors">{sol.title}</Link>
              </li>
            ))}
            <li><Link to="/pricing" className="hover:text-orange-500 transition-colors">Pricing</Link></li>
            <li><Link to="/blog" className="hover:text-orange-500 transition-colors">Insights</Link></li>
          </ul>
        </div>
        <div className="space-y-4">
          <h5 className="font-bold text-white/40 uppercase tracking-widest text-[10px]">White-Label</h5>
          <ul className="space-y-3 text-white/60">
            <li><Link to="/white-label" className="hover:text-orange-500 transition-colors">Overview</Link></li>
            <li><Link to="/white-label" className="hover:text-orange-500 transition-colors">Customization</Link></li>
            <li><Link to="/white-label" className="hover:text-orange-500 transition-colors">Branding</Link></li>
            <li><Link to="/white-label" className="hover:text-orange-500 transition-colors">Architecture</Link></li>
          </ul>
        </div>
        <div className="space-y-4">
          <h5 className="font-bold text-white/40 uppercase tracking-widest text-[10px]">Legal</h5>
          <ul className="space-y-3 text-white/60">
            <li><Link to="/terms" className="hover:text-orange-500 transition-colors">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-orange-500 transition-colors">Privacy</Link></li>
            <li><Link to="/cookies" className="hover:text-orange-500 transition-colors">Cookies</Link></li>
            <li><Link to="/sitemap" className="hover:text-orange-500 transition-colors">Sitemap</Link></li>
          </ul>
        </div>
        <div className="space-y-4">
          <h5 className="font-bold text-white/40 uppercase tracking-widest text-[10px]">Social</h5>
          <ul className="space-y-3 text-white/60">
            <li><a href="#" className="hover:text-orange-500 transition-colors" aria-label="Visit our LinkedIn page">LinkedIn</a></li>
            <li><a href="#" className="hover:text-orange-500 transition-colors" aria-label="Visit our Twitter page">Twitter</a></li>
          </ul>
        </div>
      </div>
    </div>
    
    <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left text-[10px] text-white/50 uppercase tracking-[0.3em] font-bold">
      <div className="space-y-1">
        <p>© {new Date().getFullYear()} SetupOnline. All rights reserved.</p>
        <p className="normal-case tracking-normal opacity-50">Vertical ERP Specialists for D2C Brands, Retail Chains, Healthcare, and Education institutes in Bangalore, India.</p>
      </div>
      <p className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
        Infrastructure: Bangalore, India
      </p>
    </div>
  </footer>
);
